<template>
    <div id="myinfo-id-no">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="identificationNo"
          name          ="identificationNo"
          type          ="text"
          class         =""
          placeholder   =""
          :value        ="identificationNo"
          @input        = "setInputValue($event.target)"
          :label        ="$t('regis-nric-fin')"
          autocomplete  ="off"
          v-show        ="isShow"
          outline
          floating-label
          required
          :disabled    = "isDisabled"
          :clear-button= "!isDisabled"
        ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      isShow:{
        type: Boolean
      },
      isDisabled:{
        type: Boolean
      },
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('myinfo', [
          'identificationNo'
      ])
    },
    methods: {
      ...mapActions('myinfo', [
        'setIdentificationNo',
        'validateInput'
      ]),

      setInputValue(inputEl){
        this.$emit("setInputValue", inputEl);
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>